import { FC } from 'react';
import { Button } from '@base/lib/Button';
import { updateConsent } from 'mod/track/GoogleConsent/utils';
import { IGoogleConsentPopupInstance } from 'mod/track/GoogleConsent/useGoogleConsentPopup';
import { Trans, useTrans } from 'base/utils/i18n';

export const RootContent: FC<IGoogleConsentPopupInstance> = props => {
    const { closeRootPopup, openCustomisePopup, openHelpPopup } = props;
    const { t } = useTrans();
    return (
        <>
            <div className={'g-desc'}>
                <Trans i18nKey={'web_consent_root_desc'} components={{ privacy: <span className={'g-help-link'} onClick={openHelpPopup}/> }}/>
            </div>
            <div className={'g-root-options'}>
                <Button
                    type={'text'}
                    onClick={openCustomisePopup}
                    className={'g-root-customise'}
                >
                    {t('web_consent_root_customise_cookies')} &gt;
                </Button>
                <Button
                    onClick={() => {
                        updateConsent({
                            preferences: false,
                            advertising: false,
                        });
                        closeRootPopup();
                    }}
                    className={'g-root-reject'}
                >
                    {t('web_consent_root_reject_all')}
                </Button>
                <Button
                    type={'primary'}
                    onClick={() => {
                        updateConsent({
                            preferences: true,
                            advertising: true,
                        });
                        closeRootPopup();
                    }}
                    className={'g-root-accept'}
                >
                    {t('web_consent_root_accept_all')}
                </Button>
            </div>
        </>
    )
};
